import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './WishLists.css';

// Components
import WishLists from '../../components/WishLists';
import NotFound from '../../routes/notFound/NotFound';
import EditWishListGroup from '../../components/WishLists/EditWishListGroup';

function WishListsContainer(props) {

  const { profileId, wishListId } = props;

  return (
    <div className={s.wishListPadding}>
      {
        wishListId && profileId && <>
          <EditWishListGroup profileId={profileId} wishListId={wishListId} />
        </>
      }
      {
        !wishListId && profileId && <>
          <WishLists profileId={profileId} />
        </>
      }
      {
        !wishListId && !profileId && <>
          <NotFound />
        </>
      }
    </div>
  );
}

WishListsContainer.propTypes = {
  profileId: PropTypes.number,
  wishListId: PropTypes.number
};

export default withStyles(s)(WishListsContainer);